import Marquee from "react-fast-marquee";

const WORDS = ["Traduction certifiée", "Sworn translation", "Присяжний переклад", "Урочистий переклад", "Interprétation judiciaire", "Interpretation", "Усный перевод", "Усне перекладацтво"];

export default function EditorialMarquee() {
  return (
    <div data-testid="editorial-marquee" className="bg-midnight border-t border-paper/10 py-7 overflow-hidden">
      <Marquee speed={18} gradient={false} pauseOnHover>
        {WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic font-light text-2xl md:text-3xl text-paper/60 mx-8 whitespace-nowrap">{w}</span>
            <span className="text-brass text-lg">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
